import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_LT.json';
import audios from './ASTROLOGY_AUDIOS_LT.json';

export const ASTROLOGY_DATA_LT: ServiceData = {
  articles,
  audios,
};
